import { Component, EventEmitter, Input, Output } from "@angular/core";

import { MatSelectionListChange } from "@angular/material/list";

import { SelectionItem } from "src/app/models/selection-list/selection-list.model";

@Component({
  selector: "selection-list",
  templateUrl: "./selection-list.component.html",
  styleUrls: ["./selection-list.component.scss"],
})
export class SelectionListComponent {
  @Input() set itemList(items: SelectionItem[]) {
    if (!items) {
      return;
    }
    this._itemList = items.map((item) => ({
      ...item,
      style: item.color
        ? `background-color: #${item.color}; color: #FFF;`
        : null,
    }));
  }
  @Input() selectedItems: string[];
  @Input() searchTooltipText: string;
  @Input() saveAction: boolean = false;

  @Output() itemsSearched: EventEmitter<string[]> = new EventEmitter<
    string[]
  >();
  @Output() itemsChanged: EventEmitter<string[]> = new EventEmitter<
    string[]
  >();
  @Output() itemsSaved: EventEmitter<any> = new EventEmitter<any>();

  _itemList: SelectionItem[];
  searchTerms: string[] = [];

  checkSelected(item: SelectionItem): boolean {
    const { code } = item;
    if (!this.selectedItems || !code) {
      return;
    }
    return this.selectedItems.some(
      (itemCode) => itemCode === code
    );
  }

  onSelectionChange(event: MatSelectionListChange) {
    const [option] = event.options;
    const { value: { code } } = option;
    const found = this.selectedItems
      ? this.selectedItems.some(
          (itemCode) => itemCode === code
        )
      : false;
    if (found) {
      this.selectedItems = this.selectedItems.filter(
        (itemCode) => itemCode !== code
      );
    } else {
      this.selectedItems = this.selectedItems
        ? [...this.selectedItems, code]
        : [code];
    }

    this.itemsChanged.emit(this.selectedItems);
  }

  onSearchChanged(searchTerms: string[]) {
    this.searchTerms = [...searchTerms];
    this.itemsSearched.emit(this.searchTerms);
  }

  selectAll() {
    this.selectedItems = this._itemList.map(({ code }) => code);
    this.itemsChanged.emit(this.selectedItems);
  }

  unselectAll() {
    this.selectedItems = [];
    this.itemsChanged.emit(this.selectedItems);
  }

  saveItems() {
    this.itemsSaved.emit();
  }
}
